import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Segment } from 'semantic-ui-react';
import { AdditivesList } from '@/components/additives/AdditivesList';

export default function AdditivesPage() {
  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - My Additives</title>
      </Helmet>
      <Container>
        <Segment vertical>
          <AdditivesList />
        </Segment>
      </Container>
    </>
  );
} 